// src/components/layout/DisclaimerModal.js
import React from 'react';

const DisclaimerModal = ({ isOpen, onAgree }) => {
  // If the modal is not open, don't render anything
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg max-w-xl w-full max-h-[90vh] overflow-auto animate-[fadeIn_0.3s_ease-out]">
        <div className="p-6 border-b">
          <h2 className="text-2xl font-serif font-bold text-gray-800">Disclaimer</h2>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-gray-700">
            In compliance with the rules of the Bar Council of India, this website of AMV LAW ("the Firm") 
            is meant solely for information about the Firm, its practice areas, advocates and solicitors 
            and not for the purpose of advertising, soliciting work or inducement of any sort by the Firm 
            or any of its members. Nor is it to be construed as legal advice of any nature or manner whatsoever.
          </p>
          <p className="text-gray-700">
            The content of this website is also the Intellectual Property of the Firm.
          </p>
          <p className="text-gray-700">
            By clicking on 'I AGREE' below, the website visitor acknowledges that the information provided 
            is meant only for his/her understanding of the Firm and its activities.
          </p>
        </div>
        <div className="p-6 border-t text-right">
          <button 
            onClick={onAgree}
            className="bg-[#1a2d44] hover:bg-[#0f1a29] text-white px-5 py-2 rounded font-medium transition duration-300"
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;